/* GlamourGallery — Announcement bar marquee init
 * Mobile + tablet only. Desktop is untouched.
 * Wraps the existing announcement text in a marquee track with one
 * cloned copy so the CSS keyframes can translateX(-50%) for a
 * seamless loop. Idempotent and safe to re-run.
 */
(function () {
  'use strict';

  var MQ_NARROW = '(max-width: 1080px)';
  var MQ_REDUCED = '(prefers-reduced-motion: reduce)';

  function init() {
    // Don't add the marquee on desktop — the message fits without scroll.
    if (!window.matchMedia || !window.matchMedia(MQ_NARROW).matches) return;
    // Respect reduced-motion: leave the text alone, CSS handles wrap.
    if (window.matchMedia(MQ_REDUCED).matches) return;

    var nodes = document.querySelectorAll('.announcement-bar__text');
    for (var i = 0; i < nodes.length; i++) {
      wrap(nodes[i]);
    }
  }

  function wrap(node) {
    if (!node || node.dataset.ggMarquee === 'done') return;
    var html = node.innerHTML.trim();
    if (!html) return;

    // Build the track: two identical copies, second one aria-hidden so
    // screen readers only announce the message once.
    var track = document.createElement('span');
    track.className = 'gg-marquee-track';

    var a = document.createElement('span');
    a.className = 'gg-marquee-copy';
    a.innerHTML = html;

    var b = document.createElement('span');
    b.className = 'gg-marquee-copy';
    b.setAttribute('aria-hidden', 'true');
    b.innerHTML = html;

    track.appendChild(a);
    track.appendChild(b);

    node.innerHTML = '';
    node.appendChild(track);
    node.dataset.ggMarquee = 'done';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run if Horizon swaps the announcement section in the editor.
  document.addEventListener('shopify:section:load', init);
})();
